export default class CookieBanner {
  constructor(elem, APP) {
    this.elem = elem;
    this.acceptButton = this.elem.querySelector(".js-cookie-accept");
    this.rejectButton = this.elem.querySelector(".js-cookie-reject");
    this.analyticsAttr = `ga-disable-${options.google_analytics_id}`;
    // this.tagAttr = `ga-disable-${options.google_tag_manager_id}`;
  }

  setCookie() {
    let expiry = new Date();
    expiry.setMonth(expiry.getMonth() + 6);
    document.cookie =
      "canvas_cookie_policy=true; expires=" + expiry.toUTCString() + "; path=/";
  }

  hasCookie() {
    return document.cookie.includes("canvas_cookie_policy");
  }

  // Load gtag.js script.
  loadScript() {
    if (options.google_analytics_id) {
      let gtagScript = document.createElement("script");
      gtagScript.async = true;
      gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${options.google_analytics_id}`;

      let firstScript = document.getElementsByTagName("script")[0];
      firstScript.parentNode.insertBefore(gtagScript, firstScript);
    }

    if (options.google_tag_manager_id) {
      let gtmScript = document.createElement("script");
      gtmScript.async = true;
      gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=${options.google_tag_manager_id}`;

      let secondScript = document.getElementsByTagName("script")[0];
      secondScript.parentNode.insertBefore(gtmScript, secondScript);
    }
  }

  enabletracking() {
    function gtag() {
      dataLayer.push(arguments);
    }

    gtag("consent", "update", {
      ad_user_data: "granted",
      ad_personalization: "granted",
      ad_storage: "granted",
      analytics_storage: "granted",
    });

    this.loadScript();
  }

  disableTracking() {
    this.loadScript();
  }

  hideUI() {
    this.elem.style.display = "none";
  }

  showUI() {
    this.elem.style.display = "block";
  }

  init() {
    if (!options.google_analytics_id && !options.google_tag_manager_id) return;

    // toggle cookie UI based on the cookie
    if (this.hasCookie()) {
      this.hideUI();
      // this.enableTracking();
    } else {
      this.showUI();
      this.disableTracking();
    }

    // accept button handler
    this.acceptButton.addEventListener("click", () => {
      this.setCookie();
      this.hideUI();
      // this.enableTracking();
    });

    // reject button handler
    this.rejectButton.addEventListener("click", () => {
      this.disableTracking();
      this.hideUI();
    });

    if (
      "doNotTrack" in navigator ||
      "msDoNotTrack" in navigator ||
      "doNotTrack" in window
    ) {
      this.elem.dataset.dnt =
        navigator.doNotTrack == "1" ||
        navigator.doNotTrack == "yes" ||
        navigator.msDoNotTrack == "1" ||
        window.doNotTrack == "1"
          ? "true"
          : "false";
    }
  }
}
